const MINUS = '−';
const MILLION = 1000000;
const THOUSAND = 1000;
/**
 * Compact COP amount for lists, cards and bars (comma decimal, es-CO).
 * >= 10 M: 1 decimal ("$12,5 M"); >= 1 M: 2 decimals ("$1,88 M");
 * < 1 M: thousands ("$350 mil"). Negatives are prefixed with a minus sign.
 */
export function formatShortCOP(n) {
    if (!Number.isFinite(n))
        return '$0';
    const abs = Math.abs(n);
    const thousands = Math.round(abs / THOUSAND);
    let body;
    if (thousands === 0) {
        body = '$0';
    }
    else if (thousands < THOUSAND) {
        body = `$${thousands} mil`;
    }
    else {
        const millions = abs / MILLION;
        body = `$${millions.toFixed(millions < 10 ? 2 : 1).replace('.', ',')} M`;
    }
    return n < 0 && thousands !== 0 ? `${MINUS}${body}` : body;
}
/** Like formatShortCOP but always signed ("+$350 mil", "−$1,20 M"); zero is "$0". */
export function formatSignedShortCOP(n) {
    const body = formatShortCOP(n);
    if (body === '$0')
        return body;
    return n < 0 ? body : `+${body}`;
}
